import React from 'react';
import { Form, Input, Button, message, Row, Col } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import PublicHeader from '../../layout/publicLayout/header';

import logo from "../../assets/images/logo-skincare.png";


interface ForgotPasswordComponentInterface {
  handleSubmission?: any
  submitting?: boolean
  form?: any
  handleBackButton?: any
}

const ForgotPasswordComponent: React.FC<ForgotPasswordComponentInterface> = (props) => {
  const { handleSubmission, submitting, form, handleBackButton } = props

  return (
    <>
      <PublicHeader />
      <div className="forgot-password-page">
        <div className="backButton">
          <Button
            icon={<ArrowLeftOutlined />}
            type="text"
            size="large"
            onClick={handleBackButton}
          />
        </div>
        <Row align={"middle"} justify="center">
          <Col span={16} xs={20} sm={20} md={16} lg={16}>
            <div className="forgot-password-page__container">
              <h2 className="title">Forgot Password?</h2>
              <p className="description">Enter the email associated with your account and we'll send you a link to reset your password.</p>
              <div className="forgot-password-page__container__form-section">
                <Form
                  name="forgot-password"
                  layout="vertical"
                  onFinish={(val) => {
                    handleSubmission(val);
                  }}
                  autoComplete="off"
                  form={form}
                >
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, message: "Please input your email!" }]}
                  >
                    <Input />
                  </Form.Item>

                  <Button htmlType="submit" block className="btn-primary" loading={submitting}>
                    Forgot Password
                  </Button>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default ForgotPasswordComponent;
